export const SET_PHONE = 'SET_PHONE'
export const SET_PHONE_TOTAL_LENGTH = 'SET_PHONE_TOTAL_LENGTH'
export const SET_PHONES = 'SET_PHONES'
export const APPEND_PHONES = 'APPEND_PHONES'
export const SET_PHONE_TEST_SENT = 'SET_PHONE_TEST_SENT'
export const SET_PHONE_TEST_SUCCESS = 'SET_PHONE_TEST_SUCCESS'
export const UPDATE_PHONE_STATUS = 'UPDATE_PHONE_STATUS'
